<div class="modal-body">
  <form>
    <div class="form-group row d-flex align-items-center">
      <label for="bus_res" class="col-12 col-form-label" style="font-size:1.5em;color:#c00;margin:20px 100px 10px 0;">
        How Many Boxes Do You Have?
      </label>
      <label for="bus_res" class="col-12 col-form-label" style="margin:10px 100px 10px 0;border-color:">
        Use this handy calculator to convert other volumes into numbers of boxes
        if you are unsure.
      </label>
      <div class="col-12" style="margin:10px 100px 10px 0;border-color:">
        <input type="number" class="form-control-plaintext" [(ngModel)]="qty" #n_input="ngModel" name="qty" style="width: 30%;display: inline;" placeholder="Quantity"/>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div class="select-wrap" style="display:inline;">
          <select class="form-control" [(ngModel)]="type" #t_select="ngModel" name="type" style="display: inline; width: 60%;">
            <!-- <option value="" selected="selected">[ select volume type ]</option> -->
            <optgroup label="Bags">
              <option value="13">Black Plastic Yard/Leaf Bag</option>
              <option value="14">Tall White Kitchen Bag</option>
            </optgroup>
            <!--<optgroup label="Storage Units">
                    <option value="1">5' x 10 ' (50 sq. ft.) - a small walk-in closet</option>
                    <option value="2">10' x 10' (100 sq. ft.) - a large walk-in closet or 1/2 of a small car garage</option>
                    <option value="3">10' x 20' (200 sq. ft.) - a garage for a compact car</option>-->
            <optgroup label="Filing Cabinets">
              <option value="11"
                >Vertical Filing Cabinet- 24" drawers - per drawer</option
              >
              <option value="12"
                >Lateral Filing Cabinet- 30" drawers - per drawer</option
              >
            </optgroup>
            <optgroup label="File Boxes">
              <option value="17">Letter/Legal (15" x 12" x 10")</option>
              <option value="18">Large Letter (24" x 12" x10")</option>
              <option value="19">Large Legal (24" x 15" x 10")</option>
            </optgroup>
            <optgroup label="Bin(s)">
              <option value="7">64 Gallon Bin</option>
              <option value="8">95 Gallon Bin</option>
            </optgroup>
            <optgroup label="Pallet(s)">
              <option value="4"
                >Stacked 4 Rows High (4 feet high) - low height</option
              >
              <option value="5"
                >Stacked 5 Rows High (5 feet high) - normal height</option
              >
              <option value="6"
                >Stacked 6 Rows High (6 feet hiigh) - maximum height - usually
                shrink-wrapped</option
              >
            </optgroup>
          </select>
        </div>
      </div>
      <label
        for="bus_res"
        class="col-12 col-form-label"
        style="font-size: 13px;margin:10px 0px;"
      >
        *Disclaimer: The conversion tool is for estimates only. Your shredding
        provider will determine final cost for services.
      </label>
      <div class="col-12">
        <button
          type="submit"
          class="form-control-plaintext"
          (click)="calculate()"
        >
          Calculate
        </button>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer" *ngIf="iboxIsSet()">
  <p class="how-much-notice text-center w-100">
    {{ ibox + " boxes " + "( " + pounds + " pounds )" }}
  </p>
</div>
